type ColorScheme = 'dark' | 'light'

export const darkDeviceIconSizeSliderStyles = (colorScheme: ColorScheme) => {
  const prefix = colorScheme === 'light' ? 'light.' : ''

  return {
    card: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '12px',
      p: '16px',
      width: '225px',
    },
    header: {
      alignItems: 'center',
      color: `${prefix}icon.primary`,
      display: 'flex',
      gap: '8px',
    },
    label: {
      color: `${prefix}text.primary`,
      textStyle: 'body',
    },
  }
}
